import React from 'react';
import { useTranslation } from 'react-i18next';
import { Icons } from '../../components/atoms/SVG';
import { PageTypeValidityPeriodBlock } from '../../_blocks/PageTypeValidityPeriod';
import { DeviatingValidityPeriodsBlock } from '../../_blocks/DeviatingValidityPeriods';
import { WidgetType } from '../../types/api/ElementType';
import { ContextWidget } from '../../types/api/Widget';
import { DefaultContextWidget } from '../_utils/asDefaultWidget';

export type PageTypeValidityPeriodWidget = ContextWidget<
  PageTypeValidityPeriodBlock | DeviatingValidityPeriodsBlock,
  WidgetType.pagetypevalidityperiod
>;

export function PageTypeValidityPeriodWidget(props: PageTypeValidityPeriodWidget) {
  const { t } = useTranslation('PageTypeValidityPeriod');
  return <DefaultContextWidget icon={Icons.FEEDBACK_POSITIVE_CHECK} title={t('widget.headline')} {...props} />;
}
